'use strict';

import React, { Component } from 'react'

import Loader from '@Pure/Loader'
import Modal  from '@Modal/Modal'

const { app, qwest } = window;

export default class DeleteModal extends Component
{
	state =
	{
		open: false,
		data: { model: '', id: '', pattern: '' },
		config: { }
	};

	componentDidMount ()
	{
		var component = this, props = this.props;

		app.push(
		{
			type: 'listener',
			event: 'open__DeleteModal',
			cb: component.open
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			type: 'listener',
			event: 'open__DeleteModal',
			cb: component.open
		});
	}

	handleClose = (e, force) =>
	{
		const component = this, props = this.props, state = this.state;

		if (component.state.loading === true && !force)
		{
			e.stopPropagation();
			return;
		}

		component.setState(
		{
			open: false,
			loading: false
		});
	}

	open = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			open : true,
			data: data,
			config: data.config
		});
	}

	delete = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			loading: true
		});

		qwest.post('/CMS/delete',
		{
			id: component.state.data.id,
			model: component.state.data.model
		})
		.then(function (xhr, response)
		{
			component.handleClose(e, true);

			app.emit('deletedCMSContent', response.deleted);
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		var loader;

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['secondary', 'bg-white'] } />;
		}

		let text = '';

		if (state.config && state.config.get__deleteModalText instanceof Function)
		{
			text = state.config.get__deleteModalText(state.data.form_data);
		}

		var output =
		(
			<Modal open={ state.open } onClose={ component.handleClose }
				title="Suppression" hide_close={ true }>

				{ text }

				<div className="c-dialog__buttons">
					<button className="c-btn c-dialog__cancel"
						onClick={ component.handleClose }>
						Annuler
					</button>

					<button className="c-btn c-dialog__danger"
						onClick={ component.delete }>
						Supprimer
					</button>
				</div>

				{ loader }

			</Modal>
		);

		return output;
	}
}
